import { Page, Text, View, Document } from "@react-pdf/renderer"
import { useTranslation } from "react-i18next"

import { isNotEmpty } from "utils/validation"
import { COMPANY_GENDER_VALUE, PRIVATE_GENDER_VALUE } from "utils"
import { dateService } from "services/date"

import { DataView, PDFHeader, styles } from "."
import { BikeCertificateProps } from "../BikeCertificate"

export const BikeCertificatePDF = ({ bike, currentOperator }: BikeCertificateProps) => {
	const { t } = useTranslation()

	const activatedBikeDate = dateService.formatDate(
		bike?.bike_last_registered_by.create_date,
		"dd/MM/y"
	)

	return (
		<Document>
			<Page size="A4" style={styles.page}>
				<PDFHeader currentOperator={currentOperator} />

				{isNotEmpty(bike) && (
					<View style={styles.section}>
						<View>
							<Text style={[styles.h1]}>
								{t("pdf.pdf_identification_title", {
									ns: "bike",
								})}
							</Text>
						</View>

						<View>
							<Text style={[styles.p]}>{t("pdf.greeting", { ns: "bike" })}</Text>
							<Text style={[styles.p]}>
								{t("pdf.explanation", {
									ns: "bike",
									bikeActivation: activatedBikeDate,
								})}
							</Text>
							<Text style={[styles.p]}>{t("pdf.more_info", { ns: "bike" })}</Text>
						</View>

						<View style={styles.grid}>
							<View style={styles.sectionRight}>
								<Text style={styles.h2}>
									{t("pdf.bike_info", {
										ns: "bike",
									})}
								</Text>
								<DataView
									label={t("description.brand", {
										ns: "bike",
									})}
									value={bike?.bike_description.brand}
								/>
								<DataView
									label={t("description.model", {
										ns: "bike",
									})}
									value={bike?.bike_description.model}
								/>
								<DataView
									label={t("description.type", {
										ns: "bike",
									})}
									value={bike?.bike_description.gear_type}
								/>
								<DataView
									label={t("description.color", {
										ns: "bike",
									})}
									value={bike?.bike_description.color}
								/>

								{bike?.bike_description?.is_electric === true && (
									<DataView
										label={t("pdf.type_electric", {
											ns: "bike",
										})}
										value={t("global.yes")}
									/>
								)}

								{bike?.bike_description?.is_electric === false && (
									<DataView
										label={t("pdf.type_electric", {
											ns: "bike",
										})}
										value={t("global.no")}
									/>
								)}

								<DataView
									label={t("description.fnuci_code", {
										ns: "bike",
									})}
									value={bike?.bike_id}
								/>

								{isNotEmpty(bike?.bike_description.frame_serial_number) && (
									<DataView
										label={t("pdf.frame", {
											ns: "bike",
										})}
										value={bike?.bike_description.frame_serial_number}
									/>
								)}
								{isNotEmpty(bike?.bike_description.engine_serial_number) && (
									<DataView
										label={t("pdf.engine", {
											ns: "bike",
										})}
										value={bike?.bike_description.engine_serial_number}
									/>
								)}
								{isNotEmpty(bike?.bike_description.battery_serial_number) && (
									<DataView
										label={t("pdf.battery", {
											ns: "bike",
										})}
										value={bike?.bike_description.battery_serial_number}
									/>
								)}
							</View>

							<View style={styles.sectionLeft}>
								<Text style={styles.h2}>
									{t("pdf.personal_info", {
										ns: "bike",
									})}
								</Text>

								{bike?.bike_owner?.gender === COMPANY_GENDER_VALUE && (
									<DataView
										label={t("raison_sociale", {
											ns: "user",
										})}
										value={bike?.bike_owner.social_reason}
									/>
								)}
								{bike?.bike_owner?.gender === PRIVATE_GENDER_VALUE && (
									<>
										<DataView
											label={t("lastname", {
												ns: "user",
											})}
											value={bike?.bike_owner.last_name}
										/>

										<DataView
											label={t("firstname", {
												ns: "user",
											})}
											value={bike?.bike_owner.first_name}
										/>
									</>
								)}
								<DataView
									label={t("phone", { ns: "user" })}
									value={bike?.bike_owner.phone.replace("+33", "0")}
								/>
								<DataView
									label={t("email", { ns: "user" })}
									value={bike?.bike_owner.mail}
								/>
							</View>
						</View>
					</View>
				)}

				<View style={[styles.bottomPage]}>
					<Text style={[styles.p]}>
						{t("pdf.signature", { ns: "bike", operator: currentOperator.name })}
					</Text>
				</View>
			</Page>
		</Document>
	)
}
